import Record from "./base"

export class Event extends Record {
  constructor(...props) {
    super(...props)
    const [model, data] = props
    if (this.digitalsign_image.indexOf("{") > -1) {
      this.digitalsign_image = JSON.parse(this.digitalsign_image)
      this.digitalsign_image = `//res.cloudinary.com/bidr/image/upload/d_defaultbrand.png/${this.digitalsign_image.image_version}/${this.auction_code}/${this.digitalsign_image.original_image_name}`
    } else {
      this.digitalsign_image = null
    }

    if (this.event_logo.indexOf("{") > -1) {
      this.event_logo = JSON.parse(this.event_logo)
      this.event_logo = `//res.cloudinary.com/bidr/image/upload/d_WhiteNoTagline_nakbpt.png/${this.event_logo.image_version}/${this.auction_code}/${this.event_logo.original_image_name}`
    } else {
      this.event_logo = ""
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/serializers/event.js